import { render } from "./EventCard.vue?vue&type=template&id=5a6ac370&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=5a6ac370&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a6ac370"

export default script